/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/whatsapp/mm_lite_api_status/:messaging_service_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsappMmLiteApiStatusMessagingServiceId } from "./constants";
import type { GetWhatsAppMmLiteStatusForMessagingServiceResult } from "./types";

export const getWhatsAppMmLiteStatusForMessagingService = reactQueryFetcherAdapter(
  engagementAppGroupIdWhatsappMmLiteApiStatusMessagingServiceId,
  (
    signal: AbortSignal,
    appGroupId: string,
    messagingServiceId: string
  ): Promise<GetWhatsAppMmLiteStatusForMessagingServiceResult> => {
    return fetch(
      `/engagement/${appGroupId}/whatsapp/mm_lite_api_status/${messagingServiceId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
